import {ChangeDetectionStrategy, Component, EventEmitter, Inject, OnInit, Output,} from "@angular/core";
import {PANEL_DATA} from "../../../../commons/angular/services/panel.service";
import * as moment from "moment";

interface VisitPlanDaySelectDialogDataInput {
  dateRange: { from: number, to: number };
  selectedDayTimestamp: number;
  schedulingProjectJobs: any[];
}

require('./visit-plan-day-select-dialog.scss');
@Component({
  standalone: false,
  selector: 'app-visit-plan-day-select-dialog',
  templateUrl: './visit-plan-day-select-dialog.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VisitPlanDaySelectDialogComponent implements OnInit {

  @Output() onClose = new EventEmitter<any>();

  public dayOptions: number[] = [];
  public selectedDayTimestamp: number;
  public schedulingProjectJobs: any[];
  public daysLeftoverJobsCountMap: any;

  constructor(@Inject(PANEL_DATA) public data: VisitPlanDaySelectDialogDataInput) {
  }

  ngOnInit() {
    this.selectedDayTimestamp = this.data.selectedDayTimestamp;
    this.schedulingProjectJobs = this.data.schedulingProjectJobs;
    this.dayOptions = this._generateTableDays(this.data.dateRange);
    this._initLeftOverCountPerDayMap();
  }

  onDaySelect(timestamp) {
    this.onClose.emit(timestamp);
  }

  onCancel() {
    this.onClose.emit()
  }

  private _generateTableDays(dateRange: { from: number, to: number }) {
    const days: number[] = [];

    let current = moment(dateRange.from).startOf("day");
    const end = moment(dateRange.to).startOf("day");

    while (current.isSameOrBefore(end, "day")) {
      days.push(current.startOf('day').valueOf());

      current = current.clone().add(1, "day");
    }

    return days;
  }

  private _initLeftOverCountPerDayMap() {
    this.daysLeftoverJobsCountMap = {};

    this.dayOptions.forEach((d) => {
      this.daysLeftoverJobsCountMap[d] = 0;
    })
    this.schedulingProjectJobs.forEach((job) => {
      if (!job.routed) {
        const timestamp = this.dayOptions.find(timestamp => {
          return moment(job.stops[0].notAfter).isBetween(moment(timestamp).startOf('day'), moment(timestamp).endOf('day'))
        })

        this.daysLeftoverJobsCountMap[timestamp] += 1;
      }
    })
  }

}
